import { MutationCache, QueryCache, QueryClientConfig } from "@tanstack/react-query";
import { notification } from "antd";
import { AxiosError } from "axios";

export const getAxiosErrorMessage = (error: AxiosError): string => {
  return (error as any)?.response?.data?.message || error.message;
};

const formatError = (handlerName: "Query" | "Mutation", error: unknown): void => {
  if (handlerName === "Mutation") {
    const err = error as AxiosError<any>;

    const errorList: Array<Array<string>> = err?.response?.data?.errors
      ? Object.entries(err?.response?.data?.errors)
      : [];

    const serializeErrors = () => {
      const serializedErrorList = errorList.map((err: Array<string>) => `${err[0]}: ${err[1]}. `);

      return serializedErrorList.join("\n");
    };

    return notification.error({
      message: "Failed",
      description:
        errorList.length > 0 ? serializeErrors() : getAxiosErrorMessage(error as AxiosError),
    });
  } else {
    console.error(
      `Global ${handlerName} error handler. `,
      "Message:",
      getAxiosErrorMessage(error as AxiosError),
      "Error object:",
      error
    );
  }
};

const getQueryClientConfig = (): QueryClientConfig => ({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
    mutations: {},
  },

  queryCache: new QueryCache({
    onError: (error) => formatError("Query", error),
  }),
  mutationCache: new MutationCache({
    onError: (error) => formatError("Mutation", error),
  }),
});

export default getQueryClientConfig;
